<template>
  <div>
    <div class="container-fluid">
      <vx-card
        title="Traspaso y Compra Venta en Mercado Primario"
        subtitle-color="dark"
        subtitle="Ingresa el id del inversionista que quiere vender o traspasar sus inversiones y busca sus proyectos para continuar"
        class="mt-3"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <vs-select
              placeholder="Seleccione"
              label="Tipo de movimiento"
              class="w-full"
              v-model="operationType"
            >
              <vs-select-item
                :key="index"
                :value="item.value"
                :text="item.text"
                v-for="(item, index) in operationTypeOptions"
              />
            </vs-select>
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>ID Inversionista. <small>(vende)</small></label>
            <vx-input-group>
              <vs-input
                type="number"
                class="w-full"
                icon-pack="feather"
                icon="icon-user"
                v-model="sellerInvestorId"
              />
              <template slot="append">
                <div class="append-text btn-addon">
                  <vs-button
                    color="dark"
                    @click="searchProjects()"
                    :disabled="!sellerInvestorId"
                    >Buscar</vs-button
                  >
                </div>
              </template>
            </vx-input-group>
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>ID Inversionista. <small>(compra)</small></label>
            <vs-input
              type="number"
              class="w-full"
              icon-pack="feather"
              :disabled="!searchComplete"
              icon="icon-user"
              v-model="buyerInvestorId"
            />
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>Comisión</label>
            <vs-input
              type="number"
              class="w-full"
              icon-pack="feather"
              disabled="true"
              icon="icon-percent"
              v-model="commissionPercentage"
            />
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>Descuento</label>
            <vs-input
              type="number"
              class="w-full"
              icon-pack="feather"
              disabled="true"
              icon="icon-percent"
              v-model="discountPercentage"
            />
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <vs-button
              class="mt-6"
              color="success"
              :disabled="
                !searchComplete ||
                !buyerInvestorId ||
                selectedProjects.length === 0
              "
              @click="confirmTransaction()"
              >Confirmar</vs-button
            >
          </div>
        </div>

        <!-- si el inversionista que vende es RG se indicar que % debe conservar por cada proyecto -->
        <div v-if="sellerInvestorId == rgInvestorId" class="vx-row">
          <div class="vx-col w-full mt-5">
            <h5><b style="color: red;">Importante:</b> Primero ingresa el porcentaje que debe conservar RG y presiona <b>"Buscar"</b> de nuevo</h5>
          </div>
          <div class="vx-col md:w-1/4 xl:w-1/3 w-full mb-2">
            <label>% De RG en cada proyecto</label>
            <vs-input
              type="number"
              class="w-full"
              icon-pack="feather"
              icon="icon-percent"
              min="0"
              max="100"
              v-model="rgInvestorMinParticipation"
            />
          </div>
        </div>

        <div class="vx-row mt-3">
          <div class="vx-col w-full">
            <h4>
              Participaciones del inversionista ({{
                sellerProjectsData.length
              }})
            </h4>
            <h5 class="bold">
              Inversión efectiva seleccionada ({{ this.explicitMoneyFormat(totalFixedInvestmentToMove)}})
            </h5>
            <label
              >Selecciona las participaciones que se verán afectadas con la
              operación:</label
            >
            <!-- Vista Tabla -->
            <div id="data-list-thumb-view" class="data-list-container">
              <vs-table
                class="mt-4"
                multiple
                stripe
                v-model="selectedProjects"
                :data="sellerProjectsData"
                noDataText="No hay registros"
              >
                <template slot="thead">
                  <vs-th class="bold" sort-key="id">PID</vs-th>
                  <vs-th class="bold" sort-key="name">NOMBRE</vs-th>
                  <vs-th class="bold" sort-key="share">PARTICIPACIÓN</vs-th>
                  <vs-th class="bold" sort-key="investment"
                    >INVERSIÓN EFECTIVA</vs-th
                  >
                </template>

                <template slot-scope="{ data }">
                  <tbody>
                    <vs-tr
                      :data="tr"
                      :key="indextr"
                      v-for="(tr, indextr) in data"
                    >
                      <vs-td
                        ><label class="pill-dark">{{ tr.id }}</label></vs-td
                      >
                      <vs-td>{{ tr.name }}</vs-td>
                      <vs-td
                        ><label class="pill-success">{{
                          decimalPercentFormat(tr.share, 13)
                        }}</label></vs-td
                      >
                      <vs-td
                        ><label class="pill-secondary">{{
                          explicitMoneyFormat(tr.fixedInvestment, 2)
                        }}</label></vs-td
                      >
                    </vs-tr>
                  </tbody>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
      </vx-card>

      <!-- POPUP RESULTADOS DE OPERACION -->
      <vs-popup
        title="Resultados de operación"
        :active.sync="popupResultsActive"
      >
        <div class="vx-row">
          <div class="vx-col md:w-1/2 w-full mb-2">
            <h5>Proyectos movidos:</h5>
            <label class="pill-success">
              {{ resultOperationData.projects_moved }}</label
            >
          </div>
          <div class="vx-col md:w-1/2 w-full mb-2">
            <h5>Proyectos no movidos:</h5>
            <label class="pill-danger">
              {{ resultOperationData.projects_not_moved }}</label
            >
          </div>
        </div>
      </vs-popup>
      <!--  -->
    </div>
  </div>
</template>

<script lang="js">
import formatHelper from '@mixins/formatHelper';
import AssetStatusEnum from "@/bl/enums/AssetStatusEnum";

export default  {
    name: 'primary-market-trading',
    props: [],
    mixins: [formatHelper],
    data() {
      return {
        rgInvestorId: 1190,
        rgInvestorMinParticipation: 0,
        sellerInvestorId: null,
        buyerInvestorId: null,
        commissionPercentage: 0,
        discountPercentage: 100,
        searchComplete: false,
        operationTypeOptions:[
            {text:'Traspaso',value:0},
            {text:'Compra-venta',value:1}
        ],
        operationType:0,
        sellerProjectsData: [],
        selectedProjects: [],
        currentSellerInvestorId: null,
        buyerInvestorInfoData: {
            id: null,
            user: {
                person_type: 1
            }
        },
        popupResultsActive:false,
        resultOperationData: {
            projects_moved: "",
            projects_not_moved: "",
        }
      }
    },
    computed: {
        isMobileScreen () {
            return this.$store.state.windowWidth <= this.mobileScreen
        },
        buyerPerson() {
            if (this.isBuyerValid) {
                return (this.buyerInvestorInfoData.user.person_type === 0 || this.buyerInvestorInfoData.user.person_type === 3) ? this.buyerInvestorInfoData.user.business : this.buyerInvestorInfoData.user.personal;
            }else{
                return null;
            }
        },
        buyerFiscalName() {
            if (this.isBuyerValid) {
                if (this.buyerInvestorInfoData.user.person_type === 1 || this.buyerInvestorInfoData.user.person_type === 2) {
                    return `${this.buyerPerson.first_name} ${this.buyerPerson.second_name} ${this.buyerPerson.last_name_1} ${this.buyerPerson.last_name_2}`
                } else {
                    return this.buyerPerson.name;
                }
            }else{
                return "";
            }
        },
        isBuyerValid() {
            return (this.buyerInvestorInfoData === "" || this.buyerInvestorInfoData.id === null) ? false:true;
        },
        totalFixedInvestmentToMove(){
          return this.selectedProjects.reduce((accumulator, object) => {
                return accumulator + object.fixedInvestment;
            }, 0);
        }
    },
    watch: {
      sellerInvestorId: function (val) {
        if (val != this.currentSellerInvestorId) {
            this.searchComplete = false;
        }else{
            this.searchComplete = true;
        }
      },
      operationType: function (val) {
        if (val == 0) {
            this.discountPercentage = 100;
        }else{
            this.discountPercentage = 0;
        }
      }
    },
    methods: {
        async searchProjects(){
            this.selectedProjects = [];
            this.sellerProjectsData = [];
            this.showLoading(true);
            try{
                const res = await axios.post(`api/inversionista/${this.sellerInvestorId}/investments`, {});
                this.sellerProjectsData = this.setProjectsData(res.data);
                if (this.sellerProjectsData.length > 0) {
                    this.searchComplete = true;
                    this.currentSellerInvestorId = this.sellerInvestorId;
                }
            }catch(e){
                if(e.response != undefined && e.response.data != undefined && e.response.data.message != undefined){
                    this.errorNotif("Aviso", e.response.data.message, 4000);
                }else{
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                }
            }
            this.showLoading(false);
        },
        setProjectsData(projects){
            let projectsFormatted = [];
            projects.forEach(f => {
                if (f.asset_status == AssetStatusEnum.VIGENTE || f.asset_status == AssetStatusEnum.BIENES_MANDATO || f.asset_status == AssetStatusEnum.OTROS_BIENES_ADMINISTRACION) {
                    let project = {
                        id: f.id,
                        name: f.alias.trim(),
                        share: f.share,
                        fixedInvestment: f.fixedInvestment,
                    };
                    // si el inversionista que vende es RG se debe quedar con el % indicado en cada proyecto
                    if (this.sellerInvestorId == this.rgInvestorId) {
                        project.share = project.share-(this.rgInvestorMinParticipation/100);
                        project.fixedInvestment = project.share*f.debitBalance;
                    }
                    if (project.share > 0) {
                        projectsFormatted.push(project);
                    }
                }
            });
            projectsFormatted.sort(function (a,b){
                return a.id - b.id;
            });
            return projectsFormatted;
        },
        async confirmTransaction(){
            if (this.currentSellerInvestorId == this.buyerInvestorId) {
                this.errorNotif("Aviso", "El inversionista que compra no puede ser el mismo que vende, verifique sus datos", 4000);
                return;
            }

            if (this.currentSellerInvestorId == this.rgInvestorId && !this.rgInvestorMinParticipation) {
                this.errorNotif("Aviso", "El porcentaje minimo para Rg no puede estar vacío, verifique sus datos", 4000);
                return;
            }

            await this.getBuyerInvestorInfo();
            if (!this.isBuyerValid) {
                this.errorNotif("Aviso", "No se encontró información del comprador, verifique sus datos", 4000);
                return;
            }

            if (this.operationType == 1 && this.buyerInvestorInfoData.final_balance < this.totalFixedInvestmentToMove) {
                this.errorNotif("Aviso", "El comprador no cuenta con saldo suficiente para completar la venta, verifique sus datos", 4000);
                return;
            }

            let title = "¿Continuar con el traspaso?";
            let message = `Se traspasarán ${this.selectedProjects.length} proyectos con una inversion fija de ${this.explicitMoneyFormat(this.totalFixedInvestmentToMove)}, del IID: ${this.currentSellerInvestorId} al IID: ${this.buyerInvestorId}`;
            if (this.operationType == 1) {
                title = "¿Continuar con la venta?";
                message = `Se realizará la venta de ${this.selectedProjects.length} proyectos con una inversion fija de ${this.explicitMoneyFormat(this.totalFixedInvestmentToMove)}, del IID: ${this.currentSellerInvestorId} al IID: ${this.buyerInvestorId}`;
            }
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: title,
                text: message,
                acceptText: "Confirmar",
                cancelText: "Cancelar",
                accept: this.executeTransaction
            })
        },
        async getBuyerInvestorInfo(){
            this.showLoading(true);
            this.buyerInvestorInfoData = "";
            try{
                const { data } = await axios.get(`/api/investor/${this.buyerInvestorId}`, {
                  params: {
                      with: [
                          'user.personal',
                          'user.business',
                      ]
                  }
                });
                this.buyerInvestorInfoData = data;
            }catch(e){
                if(e.response != undefined && e.response.data != undefined && e.response.data.message != undefined){
                    this.errorNotif("Aviso", e.response.data.message, 4000);
                }else{
                    console.log(e);
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                }
            }
            this.showLoading(false);
        },
        async executeTransaction(){
            this.showLoading(true);
            try{
                let projectIds = this.selectedProjects.map(a => a.id);
                const res = await axios.post(`api/backoffice/investor/createInvestorSellingOrder`, {
                    operation_type: this.operationType,
                    projects_ids_to_move: projectIds,
                    seller_investor_id: this.currentSellerInvestorId,
                    buyer_investor_id: this.buyerInvestorId,
                    discount_percentage: this.discountPercentage,
                    commission_percentage: this.commissionPercentage,
                    rg_min_participation: this.rgInvestorMinParticipation/100
                });
                this.resultOperationData = res.data;
                await this.searchProjects();
                this.popupResultsActive=true;
            }catch(e){
                if(e.response != undefined && e.response.data != undefined && e.response.data.message != undefined){
                    this.errorNotif("Aviso", e.response.data.message, 4000);
                }else{
                    console.log(e);
                    this.errorNotif("Aviso", 'Parece que ha ocurrido un error, intente más tarde', 4000);
                }
            }
            this.showLoading(false);
        }
    }
}
</script>

<style>
.con-vs-dialog {
  z-index: 100000 !important;
}
</style>
